import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { GrupoClassificacaoMultiselectComponent } from './grupo-classificacao-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        GrupoClassificacaoMultiselectComponent
    ],
    exports: [
        GrupoClassificacaoMultiselectComponent
    ]
})
export class GrupoClassificacaoMultiselectModule { }
